// Browser preferences are scoped to a location; identity is validated by the API.
const keyFor = boxId => `selectedLocationWindow:${boxId}`;
export const activeWindows = windows => (windows || []).filter(item => item.is_active === true);
export const getRememberedWindow = boxId => {
  try { return JSON.parse(localStorage.getItem(keyFor(boxId)) || 'null'); } catch (_) { return null; }
};
export const rememberWindow = (boxId, selected) => {
  try {
    if (selected) localStorage.setItem(keyFor(boxId), JSON.stringify({ id: selected.id, name: selected.name }));
    else localStorage.removeItem(keyFor(boxId));
  } catch (_) { /* Selection remains usable in component state. */ }
};
export const resolveRememberedWindow = (boxId, windows) => {
  const stored = getRememberedWindow(boxId);
  return activeWindows(windows).find(item => stored && item.id === stored.id) || null;
};
export const windowRequestContext = selected => selected ? { location_window_id: selected.id } : {};
export const locationWindowsRequest = async (boxId, options = {}) => {
  const user = JSON.parse(sessionStorage.getItem('user') || 'null');
  const token = user && user.signInUserSession && user.signInUserSession.idToken.jwtToken;
  const response = await fetch(`${process.env.REACT_APP_BASEURL}boxes/${encodeURIComponent(boxId)}/windows`, {
    ...options,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, ...(options.headers || {}) },
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.message || 'Unable to load windows.');
  return body;
};

// Terminal payments validate the selected window before dispatch; no selection is needed
// when the location has no active windows. Other operations do not use this context.
export const validateTerminalWindowContext = async (boxId, context = {}) => {
  if (!context.location_window_id) return {};
  const result = await locationWindowsRequest(boxId);
  if (activeWindows(result.windows).some(row => row.id === context.location_window_id)) return context;
  const stored = getRememberedWindow(boxId);
  if (stored && stored.id === context.location_window_id) rememberWindow(boxId, null);
  throw new Error('The selected window is no longer available. Reload the location and select a window.');
};



// WEBPACK FOOTER //
// ./src/utils/locationWindows.js